import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cx } from '@platform/core/lib/cx';
import { useLabel } from '@platform/hooks/useLabel';
import { appRoutes } from '../../shell/appRoutes';
import type { IModuleFlags } from '../../shell/IModuleFlags';
import { builderTypeName } from './builderTypeName';
import type { IBuilderModuleListProps } from './IBuilderModuleListProps';

/**
 * Колонка «Визначення модулів» конструктора (прототип v4 bMods): кожен тип запису простору (власні модулі — наприкінці) — назва 500 і
 * «ПРЕФІКС · N полів · базовий» моноширинним 11px (вимкнений у просторі модуль — «· вимкнено»); вибраний — --accent-soft з акцентною
 * назвою; «+ Новий модуль» (пунктирна рамка) створює власний модуль простору (ADR-025) і відкриває його визначення.
 */
export function BuilderModuleList({ catalog, types, current, onCreate, canCreate, creating }: IBuilderModuleListProps) {
  const { t } = useTranslation();
  const label = useLabel();
  return (
    <nav className="cu-builder__list" aria-label={t('sysCust.builder.definitions')}>
      <div className="cu-builder__eyebrow">{t('sysCust.builder.definitions')}</div>
      {types.map((row) => {
        const fields = row.rt.fields.filter((f) => !f.hidden).length;
        const off = !!(catalog?.modules.find((m) => m.key === row.def.module.key) as IModuleFlags | undefined)?.disabled;
        const meta = [row.rt.prefix, t('sysCust.builder.fields', { count: fields }), row.def.module.core && row.rt.main ? t('sysCust.builder.core') : '',
          off ? t('sysCust.builder.off') : ''].filter(Boolean).join(' · ');
        return (
          <NavLink key={row.rt.key} to={appRoutes.customize('builder', row.rt.key)} className={cx('cu-builder__item', row.rt.key === current && 'is-active')}>
            <span className="cu-builder__name">{builderTypeName(row, catalog, label)}</span>
            <span className="cu-builder__meta">{meta}</span>
          </NavLink>
        );
      })}
      <button type="button" className="cu-builder__new" disabled={!canCreate || creating} title={creating ? t('sysCust.builder.creating') : undefined} onClick={onCreate}>
        {t('sysCust.builder.newModule')}
      </button>
    </nav>
  );
}
